module.exports = __webpack_public_path__ + "img/newItem-title.2b89dee1.jpg";